import './App.scss';
import './index.scss';

import ReactDOM from 'react-dom/client';
import App from 'App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import PWAPrompt from 'react-ios-pwa-prompt';
import swDev from 'swDev';
import PushNotificationLayout from 'utils/PushNotificationLayout';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        // console.log('Service Worker registered:', registration);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
// if ('serviceWorker' in navigator && 'PushManager' in window) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/service-worker.js')
//       .then((registration) => {
//         console.log('Service Worker registered with scope:', registration.scope);

//         // Handle push notification subscription or other logic here
//       })
//       .catch((error) => {
//         console.error('Service Worker registration failed:', error);
//       });
//   });
// }

// If a deploy removed the chunk the page asked for, reload once to pick up the
// new index.html instead of leaving a blank screen. CloudFront answers a missing
// /static/ file with index.html (200), so the browser usually reports
// "Unexpected token '<'" rather than a ChunkLoadError.
const CHUNK_ERROR_RE =
  /ChunkLoadError|Loading (CSS )?chunk .* failed|Unexpected token '?<'?|expected expression, got '<'/i;
const RELOAD_KEY = 'chunkReloadedAt';
const reloadOnChunkError = (message: string = '') => {
  if (!CHUNK_ERROR_RE.test(message)) return;
  // Allow a retry after a minute, but never loop on a genuinely broken deploy.
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
  if (Date.now() - last < 60000) return;
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
};
window.addEventListener('error', (e) => reloadOnChunkError(e.message || e.error?.name));
window.addEventListener('unhandledrejection', (e) =>
  reloadOnChunkError(`${e.reason?.name || ''} ${e.reason?.message || ''}`)
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    <PushNotificationLayout>
      <App />
      {/* <PWAPrompt /> */}
    </PushNotificationLayout>
  </>
);
document.body.classList.add('site-set');

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// The Workbox worker (service-worker.js) precaches index.html and competes with
// /sw.js and /firebase-messaging-sw.js for the same scope, which left users on a
// stale shell after deploys. /sw.js (registered by swDev) is the only caching worker.
// serviceWorkerRegistration.register();
swDev();
